import { useEffect, useState } from "react";
import "./pricerange.css";
import { printDebugLog } from "../../Utils/utils";

const PriceRangeSlider = ({
  productState, productDispatch,
  filtersState, filtersDispatch, maxMinPrice }) => {
  const [tempMin, setTempMin] = useState(filtersState?.priceRange[0] ?? Number(maxMinPrice?.min) ?? 0);
  const [tempMax, setTempMax] = useState(filtersState?.priceRange[1] ?? Number(maxMinPrice?.max) ?? 0);

  const [sliderMinValue, setSliderMinValue] = useState(maxMinPrice?.min);
  const [sliderMaxValue, setSliderMaxValue] = useState(maxMinPrice?.max);

  useEffect(() => {
    if (maxMinPrice) {
      printDebugLog("PriceRangeSlider", maxMinPrice);
      setSliderMinValue(maxMinPrice.min);
      setSliderMaxValue(maxMinPrice.max);

      setTempMax(sliderMaxValue);
      setTempMin(sliderMinValue);
    }
  }, [maxMinPrice]);


  const filterProductsByPrice = (products, minPrice, maxPrice) => {
    const filteredProducts = [...products];

    return filteredProducts.filter(product => {
      const price = product?.bigPrice?.productmrPrice ?? 0;
      if (price === 0) return false;
      return price >= minPrice && price <= maxPrice;
    });
  }


  const handleMinChange = (e) => {
    const val = Math.min(Number(e.target.value), tempMax - 1);
    setTempMin(val);
    filtersDispatch({
      type: "setPriceRange",
      payload: [val, tempMax],
    });

    productDispatch({ type: "setProducts", payload: filterProductsByPrice(productState?.originalProducts ?? [], val, tempMax) });
  };

  const handleMaxChange = (e) => {
    const val = Math.max(Number(e.target.value), tempMin + 1);
    setTempMax(val);
    filtersDispatch({
      type: "setPriceRange",
      payload: [tempMin, val],
    });
    productDispatch({ type: "setProducts", payload: filterProductsByPrice(productState?.originalProducts ?? [], tempMin, val) });
  };

  return (
    <div className="dual-slider-wrapper">
      <div className="slider-container">
        <label className="label-left">₹ {tempMin}</label>
        <div className="slider-inputs">
          <input
            name="a"
            min={sliderMinValue}
            max={sliderMaxValue}
            onChange={handleMinChange}
            type="range"
            value={tempMin}
          />
          <input
            name="b"
            min={sliderMinValue}
            max={sliderMaxValue}
            className="b"
            onChange={handleMaxChange}
            type="range"
            value={tempMax}
          />
        </div>
        <label className="label-right">₹ {tempMax}</label>
      </div>
    </div>
  );
};

export { PriceRangeSlider };
